import { useState } from "react";

// Avatar reutilizabil: dacă userul are poză (avatar_url) o afișează; altfel cerc colorat cu inițiala.
// `className` controlează mărimea/ring-ul cercului (ex. "w-7 h-7 ring-2 ring-white").
// `textClassName` controlează mărimea inițialei (ex. "text-xs", "text-[10px]").
export default function UserAvatar({ user, className = "w-7 h-7", textClassName = "text-xs", title }) {
    const [imgError, setImgError] = useState(false);
    const name = user?.nickname || user?.name || user?.email || "?";
    const initial = (name?.[0] || "?").toUpperCase();
    const url = user?.avatar_url;
    const base = `rounded-full flex items-center justify-center flex-shrink-0 overflow-hidden ${className}`;

    if (url && !imgError) {
        return (
            <span className={base} title={title || name}>
                <img src={url} alt="" className="w-full h-full object-cover"
                    loading="lazy" onError={() => setImgError(true)} />
            </span>
        );
    }
    return (
        <span className={base} title={title || name} style={{ backgroundColor: user?.avatar || "#002FA7" }}>
            <span className={`text-white font-bold ${textClassName}`}>{initial}</span>
        </span>
    );
}
